import { useField } from 'react-final-form';

const typeToIndex: Record<string, number> = {
  driver_front_tire: 0,
  // driver_front_wheel: 1,
  // vin_plate: 2,
  driver_rear_tire: 3,
  // driver_rear_wheel: 4,
  passenger_rear_tire: 6,
  // passenger_rear_wheel: 6,
  passenger_front_tire: 8
  // passenger_front_wheel: 8,
  // license_plate_registration: 9
};

export const useTiresGrade = (sectionId: string) => {
  const [level1, _0, level2, _1, level3] = sectionId.split('.');
  const imageIndex = typeToIndex[level3];
  const { input: imageGradeInput } = useField(`${level1}.subsections.${level2}.images.${imageIndex}.grade`);
  const { input: sectionInput } = useField(`${sectionId}.grade`);

  const changeGradeBasedOnNumber = (num: number) => {
    imageGradeInput.onChange(num);
    if (num <= 2) {
      return sectionInput.onChange('poor');
    }
    if (num === 3) {
      return sectionInput.onChange('fair');
    }

    return sectionInput.onChange('good');
  };

  return { changeGradeBasedOnNumber, value: imageGradeInput.value, imageIndex };
};
